

import { Link } from 'react-router-dom';

// Pass `to` for an in-app route (client-side navigation), `href` for anything
// external or not yet built.
function FooterLink({ href, to, children, className = '' }) {
  const baseClasses = 'text-sm text-gray-500 dark:text-gray-400 hover:text-green-700 dark:hover:text-green-400 transition-colors';
  const combinedClasses = `${baseClasses} ${className}`.trim();

  if (to) {
    return (
      <Link className={combinedClasses} to={to}>
        {children}
      </Link>
    );
  }

  return (
    <a className={combinedClasses} href={href}>
      {children}
    </a>
  );
}

export default FooterLink;
